<template>
  <div class="modal-card" :class="$style.container">
    <header class="modal-card-head">
      <p class="modal-card-title">View Project Ownership History</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body" :class="$style.body">
      <template v-if="projectOwnerHistoryLog.length > 0">
        <div v-for="(info, index) in projectOwnerHistoryLog" :key="index">
          <p :class="$style.dateStyle">{{ getEventOccuredAt(info) }}</p>
          <br />
          <p v-if="info.isOriginalProjectOwner">
            Project created by <b>{{ info.originalProjectOwnerName }}</b>
          </p>
          <p v-else>
            Project administrator changed from
            <b>{{ info.formerProjectOwner }}</b> to
            <b>{{ info.newProjectOwner }}</b>
          </p>
          <hr />
        </div>
      </template>
      <div :class="$style.noDataState" v-else>No History found</div>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { cloneDeep as _cloneDeep } from 'lodash';
import {
  isDifferent,
  isTruthy,
  isDifferentDeep,
} from '../../../jbi-shared/util/watcher.vue-decorator';
import { RootState } from '../../../store/store';
import { get as _get } from 'lodash';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../../utils/date.util';
import BaseDropDown from '../../../components/base/BaseDropDown.vue';

@Component({
  components: {
    BaseDropDown,
  },
})
export default class ProjectOwnerHistory extends Vue {
  @Prop()
  public projectOwnerHistoryLog!: any;

  public originalProjectOwner: string = '';
  public dateEventOccured: Date = new Date();

  public getEventOccuredAt(info: any) {
    return dayjs(new Date(info.eventOccuredAt)).format(DATE_FORMAT);
  }
}
</script>

<style lang="scss" module>
.body {
  min-height: 200px;
}
.triggerButton {
  width: 100%;
  justify-content: space-between;
}
.container {
  :global(.modal-card-body) {
    overflow: visible;
  }

  .triggerButton {
    width: 100%;
    justify-content: space-between;

    span {
      font-weight: normal;
    }
  }

  .dropdownContainer {
    :global(.dropdown-menu) {
      padding-top: 0;
      overflow-y: auto;
      max-height: 250px;

      :global(.dropdown-content) {
        padding-top: 0;
        padding-bottom: 0;

        :global(.dropdown-item) {
          padding: 0rem;
          border-bottom: 0.5px solid $grey-border;

          &:hover,
          label {
            background: #f7fbff;
            cursor: pointer;
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }

    .item {
      padding: 0.75rem;
      display: flex;

      input {
        margin-right: 1rem;
      }

      span {
        color: #9f9f9f;
      }
    }
  }
}
.noDataState {
  padding: 1rem;
  font-size: 18px;
  font-weight: bold;
  color: #9f9f9f;
  text-align: center;
  height: 155px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.dateStyle {
  font-size: 14px;
  color: #9e9e9e;
}
</style>
